import { Injectable } from '@angular/core';

declare var window: any;
@Injectable({
  providedIn: 'root'
})
export class AppConfigService {

    private config = window.APP_CONFIG;

    get baseAPIUrl(): string {
        return this.config?.baseAPIURL;
    }

    get baseAppUrl(): string {
        return this.config?.baseAppURL;
    }
}
